import { Routes } from '@angular/router';

import { LoggedInGuard } from './core/guards/logged-in.guard';
import { AuthorizationGuard } from './core/guards/authorization.guard';
import { MobileGuard } from './core/guards/mobile.guard';
import { features } from './core/constants/features';
import { RedirectComponent } from './components/redirect/redirect.component';
import { WindowPLus2Routes } from '~/pages/window/window.module';

export const routes: Routes = [
  // Welcome New User
  {
    path: 'welcome-new-user',
    loadChildren: () =>
      import(
        /* webpackChunkName: "welcome-new-user-mobile-plus2" */ './pages/welcome-new-user-mobile-plus2/welcome-new-user-mobile-plus2.component'
      ).then((m) => m.WelcomeNewUserMobileRoutes),
    canActivate: [LoggedInGuard],
  },

  // Betting & Coupon
  {
    path: 'bet',
    loadComponent: () =>
      import(/* webpackChunkName: "bet-page-mobile" */ './pages/bet-page-mobile/bet-page-mobile.component').then(
        (m) => m.BetPageMobileComponent,
      ),
    canActivate: [MobileGuard],
  },
  {
    path: 'coupon',
    loadComponent: () =>
      import(/* webpackChunkName: "coupon-page-mobile" */ './pages/coupon-page-mobile/coupon-page-mobile.component').then(
        (m) => m.CouponPageMobileComponent,
      ),
    canActivate: [MobileGuard],
  },
  {
    path: 'bonus-transfer',
    canActivate: [MobileGuard],
    loadComponent: () =>
      import(
        /* webpackChunkName: "credit-bonus-transfer" */ './containers/dialogs/credit-bonus-transfer/credit-bonus-transfer.component'
      ).then((m) => m.CreditBonusTransferComponent),
  },
  {
    path: 'create-card',
    canActivate: [MobileGuard, LoggedInGuard, AuthorizationGuard],
    data: { roles: features.PANEL },
    loadComponent: () =>
      import(/* webpackChunkName: "create-card-page-mobile" */ './pages/create-card-page-mobile/create-card-page-mobile.component').then(
        (m) => m.CreateCardPageMobileComponent,
      ),
  },
  {
    path: 'forgot-password',
    canActivate: [MobileGuard],
    loadComponent: () =>
      import(
        /* webpackChunkName: "forgot-password-mobile-plus2" */ '~/pages/forgot-password-mobile-plus2/forgot-password-mobile-plus2.component'
      ).then((m) => m.ForgotPasswordMobilePlus2Component),
  },
  // Auxiliary & Printing
  {
    path: 'card-details',
    canActivate: [MobileGuard],
    loadComponent: () =>
      import(/* webpackChunkName: "card-details-page-mobile" */ './pages/card-details-page-mobile/card-details-page-mobile.component').then(
        (m) => m.CardDetailsPageMobileComponent,
      ),
  },
  {
    path: 'print',
    outlet: 'printing',
    loadChildren: () => import(/* webpackChunkName: "printing" */ './components/printing/printing.component').then((m) => m.routes),
  },
  // Metadados do deploy (gerados em tempo de build — ver scripts/generate-build-info.mjs)
  {
    path: 'deploy-info',
    loadComponent: () =>
      import(/* webpackChunkName: "deploy-info" */ './pages/deploy-info/deploy-info.component').then((m) => m.DeployInfoComponent),
  },
  // Default Window Route (lazy-loaded)
  {
    path: '',
    loadChildren: () => WindowPLus2Routes,
    data: { preload: true, root: true },
  },
  // Wildcard route
  {
    path: '**',
    pathMatch: 'full',
    component: RedirectComponent,
  },
];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, {
//       scrollPositionRestoration: 'enabled',
//       preloadingStrategy: PreloadStrategy,
//       initialNavigation: 'enabledBlocking',
//     }),
//   ],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {
//   constructor(private readonly router: Router) {}

//   public addDynamicRoute(path: string, loadComponent: any, data?: any): void {
//     const newRoute = { path, loadComponent, data };
//     this.router.config.splice(1, 0, newRoute);
//     this.router.resetConfig(this.router.config);
//   }
// }
